@if (showComponent()) {
    <div class="container-fluid well">
        @if (isDigitalOrPortalPlan()) {
            <h5>{{title}}</h5>
            <h6>{{getCertificationInstructionLabel()}}</h6>
            <div class="row">
                <div class="col-xs-6">
                    <label
                        class="control-label required-input"
                        for="certificationText">
                        {{getCertificationTypeDisplayLabel()}}
                    </label>
                    <div
                        class="input-group"
                        [ngClass]="{'has-error': certificationText | formFieldHasError}">
                        <span class="input-group-addon corner">
                            <i class="nlrp-icon nlrp-icon-edit corner-icon"></i>
                        </span>
                        <textarea
                            class="form-control"
                            name="certificationText"
                            id="certificationText"
                            placeholder="Enter certification text"
                            title="Enter certification text"
                            rows="8"
                            cols="60"
                            maxlength="1000"
                            required
                            [disabled]="isReadonly()"
                            [(ngModel)]="getCertification().certificationText"
                            #certificationText="ngModel">
                        </textarea>
                    </div>
                </div>
                @if (getCertification().surveyRegulatoryStatementApplies) {
                    <div class="col-xs-6">
                        <label
                            class="control-label required-input"
                            for="surveyRegulatoryStatement">
                            {{surveyStatementTitle}}
                        </label>
                        <div
                            class="input-group"
                            [ngClass]="{'has-error': surveyRegulatoryStatement | formFieldHasError}">
                            <span class="input-group-addon corner"><i class="nlrp-icon nlrp-icon-edit corner-icon"></i></span>
                            <textarea
                                class="form-control"
                                name="surveyRegulatoryStatement"
                                id="surveyRegulatoryStatement"
                                placeholder="Enter a {{surveyStatementTitle}}"
                                title="Enter a {{surveyStatementTitle}}"
                                rows="8"
                                cols="60"
                                maxlength="1000"
                                required
                                [disabled]="isReadonly()"
                                [(ngModel)]="getCertification().surveyRegulatoryStatement"
                                #surveyRegulatoryStatement="ngModel">
                            </textarea>
                        </div>
                    </div>
                }
            </div>
            <div class="row">
                <div class="col-xs-6">
                    <button
                        id="resetRegulation45"
                        type="button"
                        class="btn btn-default nlr-btn-sm validate"
                        title="Save the Plan Information"
                        (click)="updateCertificationType()"
                        [disabled]="isReadonly()">
                        Reset
                    </button>
                </div>
                @if (getCertification().surveyRegulatoryStatementApplies) {
                    <div class="col-xs-6">
                        <button
                            id="resetSurveyStatement"
                            type="button"
                            class="btn btn-default nlr-btn-sm validate"
                            title="Save the Plan Information"
                            (click)="updateRegulatoryStatement()"
                            [disabled]="isReadonly()">
                            Reset
                        </button>
                    </div>
                }
            </div>
        }
        <div class="row">
            <div class="col-xs-6">
                <label
                    class="control-label required-input"
                    for="certifyingSurveyor">
                    Certifying surveyor name
                </label>
                <div
                    class="input-group"
                    [ngClass]="{'has-error': (certifyingSurveyor | formFieldHasError) || (certifyingSurveyorName && !getPlanModel().certifyingSurveyor)}">
                    <span class="input-group-addon">
                        <i class="nlrp-icon nlrp-icon-edit"></i>
                    </span>
                    <input
                        type="text"
                        id="certifyingSurveyor"
                        name="certifyingSurveyor"
                        class="form-control"
                        title="Select the certifying surveyor name"
                        placeholder="Search certifying surveyor"
                        required
                        autocomplete="off"
                        [disabled]="isReadonly()"
                        [nlrTypehead]="surveyorNameSearch"
                        (itemSelected)="surveyorSelected($event)"
                        [(ngModel)]="certifyingSurveyorName"
                        #certifyingSurveyor="ngModel"
                        #certifyingSurveyorInput />
                    <span class="input-group-addon">
                        <i class="nlrp-icon nlrp-icon-search"></i>
                    </span>
                </div>
            </div>
        </div>
    </div>
}
